import PropTypes from 'prop-types';
import upperFirst from 'lodash/upperFirst';
import { useTranslation } from '@eti/providers';
import ReviewModalSection from './ReviewModalSection';
import ReviewProductItem from './ReviewProductItem';

const ReviewModalExtraProducts = ({ extraProducts, onAdd }) => {
  const { t } = useTranslation();

  return (
    <>
      <ReviewModalSection
        dataTestId="travelerDetails-reviewModal-extraProducts-section"
        subtitle={t('TravelerDetails.Review.Modal.ExtraProducts.NotSelected.Header.Text')}
        title={t('TravelerDetails.Review.Modal.ExtraProducts.NotSelected.Header.Label')}
      >
        {extraProducts.map((product) => (
          <ReviewProductItem
            id={product.name}
            key={product.name}
            onAdd={onAdd}
            priceRaw={product.price}
            priceText={product.priceText}
            subtitle={t(
              `TravelerDetails.Review.Modal.${upperFirst(product.name)}.Info.Placement.Text`,
            )}
            title={product.title}
          />
        ))}
      </ReviewModalSection>
    </>
  );
};

ReviewModalExtraProducts.propTypes = {
  extraProducts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      price: PropTypes.number,
      priceText: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  onAdd: PropTypes.func,
};

export default ReviewModalExtraProducts;
